<script setup lang="ts">
import { useLocale } from 'vuetify'
import i18n from '@/plugins/i18n'
import { DevBar, LeaveWarningModal, NonStandardStudentBar, StartupModal } from '@/components/app'
import StudentSelectYearModal from '@/components/students/SelectYearModal.vue'
import StudentSetCurrentModal from '@/components/students/SetCurrentModal.vue'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useStudentStore } from '@/stores/student'

const appStore = useAppStore()
const authStore = useAuthStore()
const studentStore = useStudentStore()

const appBorderClass = computed(() => {
  if (authStore.is_shadowing) return 'app-border--shadowing'
  if (studentStore.is_trial) return 'app-border--trial'
  return ''
})

const { snackbar } = storeToRefs(appStore)
const snackbarActive = ref(false)

const { current } = useLocale()

watch(
  () => i18n.global.locale.value,
  newLocale => {
    // Sync Vuetify locale with vue-i18n locale
    current.value = newLocale
  },
  { immediate: true },
)

watch(snackbar, () => {
  snackbarActive.value = true
})

// Apply font class to body element for dropdown, toast, etc. elements
watch(() => studentStore.fontStyle, (newFontStyle) => {
  // Remove all previous font classes from body
  document.body.className = document.body.className.replace(/\bfont-\w+/g, '').trim()

  if (newFontStyle !== 'inherit') {
    document.body.classList.add(`font-${newFontStyle}`)
  }
}, { immediate: true })


</script>

<template>
  <VLocaleProvider>
    <div :class="['app-border', appBorderClass]">
      <VApp id="app">
      <NonStandardStudentBar />
      <RouterView />
      <VSnackbar
        v-model="snackbarActive"
        :color="snackbar.colour"
        :min-height="snackbar.multiLine ? 68 : undefined"
        :timeout="snackbar.timeout"
        :variant="snackbar.variant"
      >
        <div
          v-dompurify-html="snackbar.text"
          class="snackbar-text"
        />
        <template #actions>
          <VBtn
            color="white"
            class="ma-2"
            @click="snackbarActive = false"
          >
            {{ $t('actions.close') }}
          </VBtn>
        </template>
      </VSnackbar>
      <LeaveWarningModal />
      <StartupModal />
      <StudentSetCurrentModal />
      <StudentSelectYearModal />
      <DevBar v-if="appStore.config.DEV_BAR" />
    </VApp>
    </div>
  </VLocaleProvider>
</template>
